// Depolama boyutu / yüzde biçimlendirme — Türkçe sayı biçimi (ondalık virgül).
export const formatBytesTR = (bytes) => {
  const b = Number(bytes) || 0;
  if (b < 1024) return `${b} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let val = b / 1024;
  let i = 0;
  while (val >= 1024 && i < units.length - 1) {
    val /= 1024;
    i += 1;
  }
  const digits = val < 10 ? 1 : (i >= 1 ? 1 : 0);
  return `${val.toLocaleString("tr-TR", { minimumFractionDigits: digits, maximumFractionDigits: digits })} ${units[i]}`;
};

export const formatPercentTR = (pct) =>
  `%${(Number(pct) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 1 })}`;

export const formatDateTimeTR = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
